import { render } from "./Rodape.vue?vue&type=template&id=d401ec64"
import script from "./Rodape.vue?vue&type=script&lang=js"
export * from "./Rodape.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__